export default __webpack_public_path__ + "static/media/logo.09939b25.svg";